/**
 * CNTLDrawer styles
 *
 * Styles for the embedded Controls section. The component renders into a host
 * (UnifiedDrawer); the host owns the wrapper, handle, panel, and chrome.
 */
export const cntlDrawerStyles = `
/* Embedded mode: render the sections row directly into a host (e.g. UnifiedDrawer) */
.cntl-embedded {
  display: flex;
  align-items: stretch;
  gap: 12px;
  font-family: inherit;
  position: relative;
}
.cntl-embedded input,
.cntl-embedded button,
.cntl-embedded label,
.cntl-embedded select { font-family: inherit; }

.cntl-section {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex-shrink: 0;
}

.cntl-section-label-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 1px;
}

.cntl-section-label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #666;
}

.cntl-help-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  padding: 0;
  border: 1px solid #9ca3af;
  border-radius: 50%;
  background: transparent;
  color: #6b7280;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.cntl-help-btn:hover {
  background: #2c5530;
  border-color: #2c5530;
  color: white;
}

/* One shared pop-up, opened by either section's "?" - spans the full
   controls row rather than anchoring to whichever button was clicked. */
.cntl-help-popup {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 6px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 12px 30px 12px 14px;
  z-index: 50;
}

.cntl-help-popup[hidden] {
  display: none;
}

.cntl-help-popup-close {
  position: absolute;
  top: 6px;
  right: 8px;
  padding: 2px;
  border: none;
  background: transparent;
  color: #9ca3af;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.cntl-help-popup-close:hover {
  color: #333;
}

.cntl-help-popup-list {
  margin: 0;
  padding: 0 0 0 18px;
  font-size: 0.8rem;
  color: #4b5563;
  line-height: 1.5;
}

.cntl-help-popup-list li {
  margin-bottom: 8px;
}

.cntl-help-popup-list li:last-child {
  margin-bottom: 0;
}

/* Attributes render as two columns (5 entries -> 3 rows) instead of one
   tall single-file list, filled in registry priority order (left-to-right,
   top-to-bottom): Favorites/Alerts, New/Price Change, Open House. */
.cntl-attributes-grid {
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 12px;
}

.cntl-option {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.15s;
  white-space: nowrap;
  line-height: 1.1;
}

.cntl-option:hover {
  opacity: 0.8;
}

.cntl-option input[type="checkbox"] {
  width: 12px;
  height: 12px;
  margin: 0;
  cursor: pointer;
  accent-color: #16a34a;
  flex-shrink: 0;
}

.cntl-option-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.9rem;
  color: #333;
}

.cntl-option-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.cntl-option-dot.for-sale { background: #22c55e; }
.cntl-option-dot.pending { background: #f59e0b; }
.cntl-option-dot.recently-sold { background: #93c5fd; }
.cntl-option-dot.off-market { background: #9ca3af; }

/* Attribute icons in the controls panel - color now comes from the shared
   attribute registry via an inline style, not a per-attribute class here. */
.cntl-option-icon {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
}
.cntl-option-icon.neighborhoods { color: #2c5530; }

/* Divider within a section */
.cntl-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 4px 0;
}

@media (max-width: 767px) {
  .cntl-section-label { font-size: 0.75rem; }
  .cntl-option-label { font-size: 0.85rem; }
}

@media (max-width: 480px) {
  .cntl-option { gap: 3px; }
  .cntl-option-label { font-size: 0.75rem; gap: 3px; }
  .cntl-option input[type="checkbox"] { width: 10px; height: 10px; }
}

/* Touch device improvements */
@media (hover: none) and (pointer: coarse) {
  .cntl-option { min-height: 20px; padding: 1px 0; }
  .cntl-option input[type="checkbox"] { width: 14px; height: 14px; }
}
`;
export function injectStyles() {
    if (document.getElementById('cntl-drawer-styles'))
        return;
    const style = document.createElement('style');
    style.id = 'cntl-drawer-styles';
    style.textContent = cntlDrawerStyles;
    document.head.appendChild(style);
}
//# sourceMappingURL=styles.js.map